import { createContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CARDS_AUTHORIZATIONS_PATH } from '../routes';

interface ICardAuthorizationsSearchContext {
  searchCardNumber(data: any): void;
  cardNumber: string;
}

export const CardAuthorizationsSearchContext =
  createContext<ICardAuthorizationsSearchContext>({
    searchCardNumber: () => {},
    cardNumber: null,
  });

export const CardAuthorizationsSearchProvider = ({ children }) => {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const [cardNumber, setCardNumber] = useState(state && state['tarjeta']);

  const contextValue = {
    searchCardNumber: (data: any) => {
      setCardNumber(data.tarjeta);
      navigate(
        {
          pathname: CARDS_AUTHORIZATIONS_PATH.replace(
            ':cardNumber',
            data.tarjeta.replace(/\d(?=\d{4})/g, 'X'),
          ),
        },
        {
          state: {
            tarjeta: data.tarjeta,
            fromPath: pathname,
            fromAuthSearch: true,
          },
        },
      );
    },
    cardNumber,
  };
  return (
    <CardAuthorizationsSearchContext.Provider value={contextValue}>
      {children}
    </CardAuthorizationsSearchContext.Provider>
  );
};
